export const ErrorIcon = (props) => {
	const { className, size = 32, margin } = props;

	return (
		<img src="gif/error.gif" width={size} height={size} className={className} style={{ margin }} />
	);
};